import axios from 'axios';
import { createAuthInterceptor } from '@features/auth/utils';
import type { GetTokenSilentlyOptions } from '@auth0/auth0-react';

const BASE_URL = import.meta.env.VITE_DYNOLANG_LOCAL_URL;
const dynolangClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

/**
 * Adds an access token interceptor to dynolang client.
 * The interceptor automatically includes the organization context when available,
 * ensuring the token has the correct claims for the selected organization.
 *
 * @param getAccessTokenSilently - Auth0 function to get access token
 */
export const addAccessTokenInterceptorToDynoLang = (
    getAccessTokenSilently: (
        options?: GetTokenSilentlyOptions,
    ) => Promise<string>,
): void => {
    dynolangClient.interceptors.request.use(
        createAuthInterceptor(getAccessTokenSilently),
    );
};

export interface Translations {
    [key: string]: string;
}

export const fetchDynolangTranslations = async (
    pageCode: string,
    language: string,
): Promise<Translations> => {
    const response = await dynolangClient.get(
        `/api/portal/${pageCode}/${language}`,
    );
    return response.data.body.content;
};
